module.exports = __webpack_public_path__ + "static/media/day25_messenger.51d6d604.gif";